import type { EnrichedEvent, IdentifyTraits, PageInfo } from "../types";
import type { Provider } from "./types";

export class ConsoleProvider implements Provider {
  readonly name = "console";
  readonly categories = ["essential"] as const;
  private loaded = false;

  async load(): Promise<void> {
    this.loaded = true;
  }
  isLoaded(): boolean {
    return this.loaded;
  }
  track(event: EnrichedEvent): void {
    // eslint-disable-next-line no-console
    console.debug(`%c[analytics:event]`, "color:#888", event.name, event);
  }
  identify(userId: string, traits?: IdentifyTraits): void {
    // eslint-disable-next-line no-console
    console.debug(`[analytics:identify]`, userId, traits);
  }
  page(page: PageInfo): void {
    // eslint-disable-next-line no-console
    console.debug(`[analytics:page]`, page);
  }
  reset(): void {
    // eslint-disable-next-line no-console
    console.debug(`[analytics:reset]`);
  }
}
